import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-grid-system';
import TeamLabel from '../shared/TeamLabel';
import { MatchRowWrapper, MatchRowWrapperInt, MatchRowDataContainer, GroupCircle, MatchLinkWrapper } from './styles';
import Label from '../shared/Label';
import { teamCLMap } from '../../utils/tableConfiguration/tableConfiguration';
import { prettyMatchUrl } from '../../common/rcs_gaz_mc_core_FE';
//import * as status from '../../constants';
const imagesURL = 'https://images2.gazzettaobjects.it/assets-mc/calcio/squadre/min/';

class MatchRowBoxed extends Component {
  /*const isHomeWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) > Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';
  const isAwayWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) < Number(matchRow.getIn(['awayTeam', 'score'])))
    && matchRow.get('status') !== 'LIVE';*/
  //const isLive = () => matchRow.get('status') === 'LIVE';


  /*const awayResPen = (matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
  const homeResPen = (matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;*/

  getGazzanetDomain = (url) => {
    let returnedDomain = 'gazzetta';
    if (url && url.hostname) {
      const site = url.hostname;
      const [, domain] = site.split('.');
      returnedDomain = domain;
    }
    return returnedDomain;
  };
  homeResPen = () => {
    const { matchRow } = this.props;
    const homeScore = matchRow.getIn(['homeTeam', 'score']);
    const homeResPen = (matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score'])) ?
      matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;
    return homeScore + homeResPen;
  }
  awayResPen = () => {
    const { matchRow } = this.props;
    const awayScore = matchRow.getIn(['awayTeam', 'score']);
    const awayResPen = (matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score'])) ?
      matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
    return awayScore + awayResPen;
  }

  formatDate = (date) => {
    const options = {
      weekday: 'long', hour: '2-digit', minute: '2-digit',
    };
    return new Date(date).toLocaleString('it-IT', options);
  };

  formatDatePosticipated = (date, days, status) => {
    const options_only_date = {
      day: '2-digit', month: '2-digit', year: '2-digit',
    };
    const options_weekday_plus_time = {
      weekday: 'long', hour: '2-digit', minute: '2-digit',
    };
    const options_date_plus_time = {
      day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit',
    };
    const nowDate = Math.round(new Date().getTime() / 1000);
    const datePosticipe = Math.round(new Date(date).getTime() / 1000);
    const calculateDatemore6 = Math.round(nowDate + ((60 * 60 * 24) * days));

    if (calculateDatemore6 >= datePosticipe) {
      return new Date(date).toLocaleString('it-IT', options_weekday_plus_time);
    } else {
      if (status === 'POSTPONED') return `RINV ${new Date(date).toLocaleString('it-IT', options_only_date)}`;
      return `${new Date(date).toLocaleString('it-IT', options_date_plus_time)}`;
    }
  };

  formatFullDate = (date) => {
    const options = {
      weekday: 'long', day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
    };
    return new Date(date).toLocaleString('it-IT', options);
  };

  isGazzanet = () => {
    let disableLink = true;
    if (process.env.REACT_APP_SITE === 'gazzanet') {
      if (window.location && window.location.hostname) {
        const site = window.location.hostname;
        switch (site) {
          case 'www.fcinter1908.it':
          case 'www.forzaroma.info':
          case 'www.calcionapoli1926.it':
          case 'dev.fcinter1908.it':
          case 'dev.forzaroma.info':
          case 'dev.calcionapoli1926.it':
            disableLink = false;
            break;
          default:
            disableLink = true;
            break;
        }
      } else {
        disableLink = true;
      }
    } else {
      disableLink = false;
    }
    return disableLink;
  };

  renderCircle = group => (
    <GroupCircle className="secondBackground">
      Gir. {group || ''}
    </GroupCircle>
  );
  render() {
    const {
      matchRow, isMobile, isHighlight, sportId, competitionId, dictionary, isCup, trackString,
    } = this.props;
    const prettyMatchUrlVal = matchRow ? prettyMatchUrl(matchRow.getIn(['homeTeam', 'teamName']), matchRow.getIn(['awayTeam', 'teamName']), matchRow.get('matchId'), sportId, competitionId, this.getGazzanetDomain(window.location)) : '';
    let teamShortHome = matchRow ? matchRow.getIn(['homeTeam', 'teamName']) : 'sq1';
    let teamShortAway = matchRow ? matchRow.getIn(['awayTeam', 'teamName']) : 'sq2';
    const newTeamHomeID = matchRow && matchRow.getIn(['homeTeam', 'teamId']);
    const newTeamAwayID = matchRow && matchRow.getIn(['awayTeam', 'teamId']);
    if (String(competitionId) === '6' || String(competitionId) === '3' || (String(competitionId) === '5' && !isMobile)) {
      teamShortHome = teamCLMap[newTeamHomeID] || teamShortHome;
      teamShortAway = teamCLMap[newTeamAwayID] || teamShortAway;
    }

    if (String(competitionId) === '941' || String(competitionId) === '4' || String(competitionId) === '352') {
      teamShortHome = teamCLMap[newTeamHomeID] || teamShortHome;
      teamShortAway = teamCLMap[newTeamAwayID] || teamShortAway;
    }

    const currentMatch = this.props.matchRow && this.props.matchRow.toJS();
    const matchDate = currentMatch && this.formatFullDate(currentMatch.date);
    const matchend = currentMatch && currentMatch.status === 'FULL' && currentMatch.finalMatchDateTime ? this.formatFullDate(currentMatch.finalMatchDateTime) : '';
    if (!matchRow || matchRow === undefined) {
      return (
        <MatchLinkWrapper
          href=""
          className="resetLink"
          disableLink={this.isGazzanet() ? 'disableLink' : ''}
          data-matchdate={undefined}
          data-matchid={undefined}
          data-matchend={undefined}
        >
          <MatchRowWrapper
            isHighlight={isHighlight}
            isGazzanet={this.isGazzanet()}
            isMobile={isMobile}
          >
            <MatchRowWrapperInt
              isMobile={isMobile}
              isCup={isCup}
              isGazzanet={process.env.REACT_APP_SITE === 'gazzanet'}
            >
              <Col
                className="flex justifyContentCenter has-background-primary preMainColorBackground"
                md={12}
                sm={12}
                xs={12}
                style={{
              paddingLeft: 0,
              paddingRight: 0,
              weight: 'bold',
            }}
              >
                <Label
                  font="narrowBold"
                  label="STATUS"
                  size={(isMobile) ? 0.75 : 0.8}
                  color={process.env.REACT_APP_SITE === 'gazzanet' ? 'white' : 'black'}
                  isCapitalize
                  margin={(isCup && isMobile) ? '2px 12px 2px 0' : '2px 0px'}
                />

              </Col>
              {!isMobile &&
              <MatchRowDataContainer>
                <Col
                  className="flex justifyContentStart"
                  md={12}
                  sm={12}
                  xs={12}
                  style={{
                  paddingLeft: '5%',
                  paddingRight: '5%',
                  height: '34px',
                  display: 'flex',
                }}
                >
                  <TeamLabel
                  //label={matchRow.getIn(['homeTeam', 'teamName'])}
                    label={teamShortHome}
                    className="firstRow"
                    color="black"
                    image="sq1.png"
                    marginLeft={0.5}
                    font="narrowRegular"
                    size={14}
                    isCorriereCalendar
                    whiteSpace={process.env.REACT_APP_SITE === 'gazzanet' ? 'normal' : ''}
                  />

                  <Label
                    label="0"
                    font="narrowBold"
                    margin={isCup ? '0px 7px' : '0px 0 0 10px'}
                    size={1.1}
                    className="realTimeScore"
                  />

                </Col>
                <Col
                  className="flex justifyContentStart"
                  md={12}
                  sm={12}
                  xs={12}
                  style={{
                  paddingLeft: '5%',
                  paddingRight: '5%',
                  height: '34px',
                }}
                >
                  <TeamLabel
                    label="sq2"
                    color="black"
                    image="undefined.png"
                    marginLeft={0.5}
                    font="narrowRegular"
                    size={14}
                    isCorriereCalendar
                    whiteSpace={process.env.REACT_APP_SITE === 'gazzanet' ? 'normal' : ''}
                  />
                  <Label
                    label="0"
                    font="narrowBold"
                    margin={isCup ? '0px 7px' : '0px 0 0 10px'}
                    size={1.1}
                    className="realTimeScore"
                  />
                </Col>
              </MatchRowDataContainer>
            }
              {isMobile &&
              <MatchRowDataContainer>
                <Col
                  className="flex justifyContentCenter"
                  md={12}
                  sm={12}
                  xs={12}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  height: isMobile ? '34px' : '34px',
                }}
                >
                  <TeamLabel
                    color="black"
                    image="shield.png"
                    marginLeft={0.5}
                    font="narrowRegular"
                    size={15}
                    isCorriereCalendar
                  />

                  <Label
                    label="0"
                    font="narrowBold"
                    margin="0px 2px 0px 6px"
                    size={1.1}
                  />

                </Col>
                <Col
                  className="flex justifyContentCenter"
                  md={12}
                  sm={12}
                  xs={12}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  height: isMobile ? '20px' : '34px',
                }}
                >
                  <TeamLabel
                    label="sq2"
                    color="black"
                    font="narrowRegular"
                    size={15}
                    isCorriereCalendar
                  />
                </Col>
                <Col
                  className="flex justifyContentCenter"
                  md={12}
                  sm={12}
                  xs={12}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  height: isMobile ? '34px' : '34px',
                }}
                >
                  <TeamLabel
                    color="black"
                    image="shield.png"
                    marginLeft={0.5}
                    font="narrowRegular"
                    size={15}
                    isCorriereCalendar
                  />

                  <Label
                    label={0}
                    font="narrowBold"
                    margin="0px 2px 0px 6px"
                    size={1.1}
                  />

                </Col>
                <Col
                  className="flex justifyContentCenter"
                  md={12}
                  sm={12}
                  xs={12}
                  style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  height: isMobile ? '20px' : '34px',
                }}
                >
                  <TeamLabel
                    label={teamShortAway}
                    color="black"
                    font="narrowRegular"
                    size={15}
                    isCorriereCalendar
                  />
                </Col>
              </MatchRowDataContainer>
            }
            </MatchRowWrapperInt>
          </MatchRowWrapper>
        </MatchLinkWrapper>);
    }
    return (
      <MatchLinkWrapper
        href={`${prettyMatchUrlVal}${trackString || ''}`}
        className="resetLink"
        disableLink={this.isGazzanet() ? 'disableLink' : ''}
        data-matchdate={matchDate}
        data-matchid={matchRow.get('matchId')}
        data-matchend={matchend}
      >
        <MatchRowWrapper
          isHighlight={isHighlight}
          isGazzanet={this.isGazzanet()}
          isMobile={isMobile}
          //href={`/test/matchcenter/Calcio/${dictionary.competitionTable.competitionLink[(competitionId)]}/partite/${matchRow.getIn(['homeTeam', 'teamName'])}-${matchRow.getIn(['awayTeam', 'teamName'])}/${matchRow.get('matchId')}/`}
        >
          {isCup && matchRow.get('group') && matchRow.get('group') !== 'undefined' && this.renderCircle(matchRow.get('group'))}
          <MatchRowWrapperInt
            isMobile={isMobile}
            isCup={isCup}
            isGazzanet={process.env.REACT_APP_SITE === 'gazzanet'}
          >
            <Col
              className={`flex justifyContentCenter has-background-primary ${matchRow.get('status') === 'LIVE' ? 'LiveMainColorBackground' : 'preMainColorBackground'}`}
              md={12}
              sm={12}
              xs={12}
              style={{
              paddingLeft: 0,
              paddingRight: 0,
              weight: 'bold',
            }}
            >
              {matchRow.get('status') === 'PREMATCH' &&
              <Label
                font="narrowBold"
                label={this.formatDatePosticipated(matchRow.get('date'), 6)}
                size={(isMobile) ? 0.75 : 0.8}
                color={process.env.REACT_APP_SITE === 'gazzanet' ? 'white' : 'black'}
                isCapitalize
                margin={(isCup && isMobile) ? '2px 12px 2px 0' : '2px 0px'}
              />
              }
              {matchRow.get('status') === 'LIVE' &&
              <Label
                font="narrowBold"
                label={dictionary.timing.header[matchRow.getIn(['timing', 'tag'])]}
                size={(isMobile) ? 0.75 : 0.8}
                color="white"
                isCapitalize
                margin={(isCup && isMobile) ? '2px 12px 2px 0' : '2px 0px'}
              />
              }
              {matchRow.get('status') === 'FULL' &&
              <Label
                font="narrowBold"
                label="FINE"
                size={(isMobile) ? 0.75 : 0.8}
                color={process.env.REACT_APP_SITE === 'gazzanet' ? 'white' : 'black'}
                isCapitalize
                margin={(isCup && isMobile) ? '2px 12px 2px 0' : '2px 0px'}
              />
              }
              {matchRow.get('status') === 'POSTPONED' &&
              <Label
                font="narrowBold"
                label="RINVIATA"
                size={(isMobile) ? 0.75 : 0.8}
                color={process.env.REACT_APP_SITE === 'gazzanet' ? 'white' : 'black'}
                isCapitalize
                margin={(isCup && isMobile) ? '2px 12px 2px 0' : '2px 0px'}
              />
              }
              {matchRow.get('status') === 'DELAYED' &&
              <Label
                font="narrowBold"
                label="RITARDATO"
                size={(isMobile) ? 0.75 : 0.8}
                color={process.env.REACT_APP_SITE === 'gazzanet' ? 'white' : 'black'}
                isCapitalize
                margin={(isCup && isMobile) ? '2px 12px 2px 0' : '2px 0px'}
              />
              }
              {matchRow.get('status') === 'ABANDONED' &&
              <Label
                font="narrowBold"
                label="ABBANDONATO"
                size={(isMobile) ? 0.75 : 0.8}
                color={process.env.REACT_APP_SITE === 'gazzanet' ? 'white' : 'black'}
                isCapitalize
                margin={(isCup && isMobile) ? '2px 12px 2px 0' : '2px 0px'}
              />
              }
              {matchRow.get('status') === 'SUSPENDED' &&
              <Label
                font="narrowBold"
                label="SOSPESO"
                size={(isMobile) ? 0.75 : 0.8}
                color={process.env.REACT_APP_SITE === 'gazzanet' ? 'white' : 'black'}
                isCapitalize
                margin={(isCup && isMobile) ? '2px 12px 2px 0' : '2px 0px'}
              />
              }
            </Col>
            {!isMobile &&
            <MatchRowDataContainer>
              <Col
                className="flex justifyContentStart"
                md={12}
                sm={12}
                xs={12}
                style={{
                  paddingLeft: '5%',
                  paddingRight: '5%',
                  height: '34px',
                  display: 'flex',
                }}
              >
                <TeamLabel
                  //label={matchRow.getIn(['homeTeam', 'teamName'])}
                  label={teamShortHome}
                  className="firstRow"
                  color="black"
                  image={`${imagesURL}${matchRow.getIn(['homeTeam', 'teamId'])}.png`}
                  marginLeft={0.5}
                  font="narrowRegular"
                  size={14}
                  isCorriereCalendar
                  whiteSpace={process.env.REACT_APP_SITE === 'gazzanet' ? 'normal' : ''}
                />
                {matchRow.get('status') === 'PREMATCH' ?
                  <Label
                    label="0"
                    font="narrowBold"
                    margin={isCup ? '0px 7px' : '0px 0 0 10px'}
                    className="realTimeScore"
                    size={1.1}
                  />
                  :
                  <Label
                    label={this.homeResPen()}
                    font="narrowBold"
                    margin={isCup ? '0px 7px' : '0px 0 0 10px'}
                    size={1.1}
                    className="realTimeScore"
                  />
                }
              </Col>
              <Col
                className="flex justifyContentStart"
                md={12}
                sm={12}
                xs={12}
                style={{
                  paddingLeft: '5%',
                  paddingRight: '5%',
                  height: '34px',
                }}
              >
                <TeamLabel
                  label={teamShortAway}
                  color="black"
                  image={`${imagesURL}${matchRow.getIn(['awayTeam', 'teamId'])}.png`}
                  marginLeft={0.5}
                  font="narrowRegular"
                  size={14}
                  isCorriereCalendar
                  whiteSpace={process.env.REACT_APP_SITE === 'gazzanet' ? 'normal' : ''}
                />
                {matchRow.get('status') === 'PREMATCH' ?
                  <Label
                    label="0"
                    font="narrowBold"
                    margin={isCup ? '0px 7px' : '0px 0 0 10px'}
                    size={1.1}
                    className="realTimeScore"
                  />
                  :
                  <Label
                    label={this.awayResPen()}
                    font="narrowBold"
                    margin={isCup ? '0px 7px' : '0px 0 0 10px'}
                    size={1.1}
                    className="realTimeScore"
                  />
                }
              </Col>
            </MatchRowDataContainer>
            }
            {isMobile &&
            <MatchRowDataContainer>
              <Col
                className="flex justifyContentCenter"
                md={12}
                sm={12}
                xs={12}
                style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  height: isMobile ? '34px' : '34px',
                }}
              >
                <TeamLabel
                  color="black"
                  image={`${imagesURL}${matchRow.getIn(['homeTeam', 'teamId'])}.png`}
                  marginLeft={0.5}
                  font="narrowRegular"
                  size={15}
                  isCorriereCalendar
                />
                {matchRow.get('status') === 'PREMATCH' ?
                  <Label
                    label="0"
                    font="narrowBold"
                    margin="0px 2px 0px 6px"
                    size={1.1}
                    className="realTimeScore"
                  />
                  :
                  <Label
                    label={this.homeResPen()}
                    font="narrowBold"
                    margin="0px 2px 0px 6px"
                    size={1.1}
                    className="realTimeScore"
                  />
                }
              </Col>
              <Col
                className="flex justifyContentCenter"
                md={12}
                sm={12}
                xs={12}
                style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  height: isMobile ? '20px' : '34px',
                }}
              >
                <TeamLabel
                  label={teamShortHome}
                  color="black"
                  font="narrowRegular"
                  size={15}
                  isCorriereCalendar
                />
              </Col>
              <Col
                className="flex justifyContentCenter"
                md={12}
                sm={12}
                xs={12}
                style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  height: isMobile ? '34px' : '34px',
                }}
              >
                <TeamLabel
                  color="black"
                  image={`${imagesURL}${matchRow.getIn(['awayTeam', 'teamId'])}.png`}
                  marginLeft={0.5}
                  font="narrowRegular"
                  size={15}
                  isCorriereCalendar
                />
                {matchRow.get('status') === 'PREMATCH' ?
                  <Label
                    label="0"
                    font="narrowBold"
                    margin="0px 2px 0px 6px"
                    size={1.1}
                    className="realTimeScore"
                  />
                  :
                  <Label
                    label={this.awayResPen()}
                    font="narrowBold"
                    margin="0px 2px 0px 6px"
                    size={1.1}
                    className="realTimeScore"
                  />
                }
              </Col>
              <Col
                className="flex justifyContentCenter"
                md={12}
                sm={12}
                xs={12}
                style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  height: isMobile ? '20px' : '34px',
                }}
              >
                <TeamLabel
                  label={teamShortAway}
                  color="black"
                  font="narrowRegular"
                  size={15}
                  isCorriereCalendar
                />
              </Col>
            </MatchRowDataContainer>
            }
            {/*<Col lg={2} md={1.5} sm={1.5} xs={1.5} style={{ paddingLeft: 0, paddingRight: '15px' }}>
            <Result
              awayRes={matchRow.getIn(['awayTeam', 'score'])}
              homeRes={matchRow.getIn(['homeTeam', 'score'])}
              status={matchRow.get('status')}
              isMobile={isMobile}
            />
          </Col>
           <Col md={2} sm={2} xs={2} style={{ paddingRight: 0, paddingLeft: 0 }}>
            {matchRow.get('status') === 'PREMATCH' ?
              <MatchTime
                date={matchRow.get('date')}
              />
              :
              <Result
                awayRes={matchRow.getIn(['awayTeam', 'score'])}
                homeRes={matchRow.getIn(['homeTeam', 'score'])}
                awayPenRes={awayResPen}
                homePenRes={homeResPen}
                status={matchRow.get('status')}
                isMobile={isMobile}
                isFav
              />
            }
          </Col>*/}
          </MatchRowWrapperInt>
        </MatchRowWrapper>
      </MatchLinkWrapper>
    );
  }
}

MatchRowBoxed.propTypes = {
  matchRow: PropTypes.any,
  isMobile: PropTypes.bool,
  isHighlight: PropTypes.bool,
  sportId: PropTypes.any,
  competitionId: PropTypes.any,
  dictionary: PropTypes.any,
  isCup: PropTypes.bool,
  trackString: PropTypes.any,
};

export default MatchRowBoxed;



// WEBPACK FOOTER //
// ./src/components/MatchRowBoxed/index.js